<template>
    <div>
        <ModalCommon :id="`ModalCopy`" :config="config" @close="handleClose()" @save="handleSave()">
            <h4 class="text-center font-weight-bold mb-4">{{ $t('managerForm.screenCopy.formCopy') }}</h4>
            <template>
                <p class="font-weight-bold" style="padding-bottom: 10px; border-bottom: 1px solid #ccc">
                    {{ $t('managerForm.screenCopy.sourceFormInformation') }}
                </p>
                <div class="ml-3">
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 120px">{{ $t('managerForm.screenCopy.ID') }} </label>
                        <div class="col-sm-10">
                            {{ dataForm.id }}
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 120px">{{ $t('managerForm.screenCopy.nameForm') }} </label>
                        <div class="col-sm-10">
                            {{ dataForm.name }}
                        </div>
                    </div>
                </div>
            </template>
            <template>
                <p class="font-weight-bold" style="padding-bottom: 10px; border-bottom: 1px solid #ccc">
                    {{ $t('managerForm.screenCopy.settingDetails') }}
                </p>
                <div class="ml-3">
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingBasic.nameCampaign') }}</label>
                        <div class="col-sm-10">
                            <Multiselect
                                :id="`select-campaign-for-form-page`"
                                :value.sync="initCopy.campaign"
                                :options="masterCampaign"
                                :config.sync="configForm.configFieldSelectCampaign"
                                @select="handleSelectCampaign"
                            />
                        </div>
                    </div>
                    <!-- フォーム名 -->
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 120px"
                            >{{ $t('managerForm.settingBasic.nameForm') }} <span class="text-danger">*</span></label
                        >
                        <div class="col-sm-10">
                            <InputText
                                :model.sync="initCopy.name"
                                :config.sync="configForm.configFieldNameForm"
                                @blur="handleValidateField(configForm.configFieldNameForm)"
                            />
                        </div>
                    </div>
                    <!-- 公開パス -->
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 120px"
                            >{{ $t('managerForm.settingBasic.publicPath') }} <span class="text-danger">*</span></label
                        >
                        <div class="col-sm-10">
                            <div class="d-flex flex-wrap align-items-center">
                                <Multiselect
                                    v-if="listCustomDomains.length > 0"
                                    :id="`select-custom-domain-modal-copy`"
                                    class="mr-2"
                                    style="max-width: 250px"
                                    :options="listCustomDomains"
                                    :value.sync="selectedCustomDomain"
                                    :config="configForm.configFieldSelectCustomDomain"
                                />
                                <span class="mr-1" style="line-height: 0.5">/form/</span>
                                <InputText
                                    :model.sync="initCopy.url_public"
                                    :config.sync="configForm.configFieldPublicPath"
                                    @blur="handleValidateField(configForm.configFieldPublicPath)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </ModalCommon>
    </div>
</template>

<script>
import { initFormCopy, configScreenCopy } from './constants';
import { validateField, validateAllField } from '@/utils/validate';
import { InputText } from '@/components/Input';
import { handleMapDataCPIntoForm, handleDataBeforeSendServer } from '../../../handlers';
import { masterMethods, managerFormMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { OPTION_MAIL_I } from '@/views/pages/phase2/manager-form/advanced/components/setting-email/constants';

import ModalCommon from '@/components/Modal/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
export default {
    name: 'ModalCopy',
    components: {
        ModalCommon,
        Multiselect,
        InputText
    },
    props: {
        config: {
            type: Object,
            default: () => {}
        },
        dataForm: {
            type: Object,
            default: () => {}
        },
        mailInfor: {
            type: Object,
            default: () => {}
        },
        masterCampaign: {
            type: Array,
            default: () => []
        }
    },
    data() {
        let defaultDomainStr = process.env.VUE_APP_DOMAIN_FORM || '';
        defaultDomainStr = defaultDomainStr.replace(/^https?:\/\//, '');
        let defaultDomain = {
            id: null,
            domain: defaultDomainStr
        };
        return {
            initCopy: initFormCopy(),
            configForm: configScreenCopy(),
            listCustomDomains: [defaultDomain],
            selectedCustomDomain: defaultDomain,
            formMail: this.mailInfor,
            listBlockForm: [],
            isLoading: false
        };
    },
    methods: {
        ...masterMethods,
        ...managerFormMethods,

        handleClose() {
            this.onReset();
        },
        handleSave() {
            let isValid = validateAllField(this.configForm);
            if (!isValid) return;
            this.onSaveCopy(this.initCopy);
        },

        async onSaveCopy(evtData) {
            delete this.formMail?.admin_mail?.form_id;
            delete this.formMail?.client_mail?.form_id;
            let copyForm = { ...this.dataForm };
            copyForm.campaign = evtData?.campaign ?? null;
            copyForm.client = evtData?.campaign ? evtData?.client ?? null : null;
            copyForm.name = evtData?.name ?? null;
            copyForm.url_public = evtData?.url_public ?? null;
            copyForm.custom_domain_id = evtData?.custom_domain_id ?? null;
            copyForm.form_pages.page_inputs?.blocks?.forEach((item) => {
                item.status_record_block = 'create'; // để xóa các id của block khi gửi lên serve
            });
            copyForm.serial_code_prizes?.forEach((prize) => {
                prize.list_product_import?.forEach((product) => {
                    product.done = 0;
                });
            });
            let payload = handleDataBeforeSendServer(copyForm);
            payload.email_setting = this.onHandleMapMail(this.formMail);
            payload.custom_domain_id = evtData?.custom_domain_id ?? null;
            if (this.isLoading) return;
            this.isLoading = true;
            try {
                const data = await this.copyFormApi(payload);
                if (data.code !== 200) {
                    showMessage(data.code, this.$bvToast, this.$t(data.message));
                    return;
                }
                this.onReset();
                this.config.model = false;
                this.$router.push({ path: '/manager-form/list' }).then(() => {
                    showMessage(data.code, this.$bvToast, 'フォームが複製されました。');
                });
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        handleValidateField(configField) {
            validateField(configField);
        },

        onHandleMapMail(data) {
            if (!data) return null;
            const adminData = data.admin_mail;
            const blockIdAdmin = this.listBlockForm?.find((item) => item.id === adminData?.block_id);
            const clientData = data.client_mail;
            const blockIdClient = this.listBlockForm?.find((item) => item.id === clientData?.block_id);

            return {
                admin_mail: {
                    ...adminData,
                    block_name: adminData?.block_id ? blockIdAdmin?.block_name : '',
                    choice_reply_address: adminData?.choice_reply_address
                        ? adminData.choice_reply_address.map((item) => this.listBlockForm?.find((block) => block.id === item)?.block_name)
                        : [],
                    email_settings_for_each_option: adminData?.email_settings_for_each_option.map((item) => ({
                        ...item,
                        block_name: blockIdAdmin?.block_name,
                        unique_key: item?.option_id
                            ? Number(blockIdAdmin?.list_options.find((option) => option.id === item?.option_id)?.unique_key)
                            : null
                    }))
                },
                client_mail: {
                    ...clientData,
                    block_name: clientData?.block_id ? blockIdClient?.block_name : '',
                    to_address: clientData?.to_address
                        ? clientData?.to_address.map((item) => this.listBlockForm?.find((block) => block.id === item)?.block_name)
                        : [],
                    email_settings_for_each_option: clientData?.email_settings_for_each_option.map((item) => {
                        const formatToAddressMailClientForEachOption =
                            item?.to_address?.length > 0
                                ? item?.to_address.map((item) => {
                                      const foundItem = this.listBlockForm?.find((block) => block.id === item);
                                      if (foundItem && foundItem.id === OPTION_MAIL_I.id) {
                                          foundItem.block_name = OPTION_MAIL_I.id;
                                      }
                                      return foundItem?.block_name;
                                  })
                                : [];
                        return {
                            ...item,
                            block_name: blockIdAdmin?.block_name,
                            unique_key: item?.option_id
                                ? Number(blockIdClient?.list_options.find((option) => option.id === item?.option_id)?.unique_key)
                                : null,
                            to_address: formatToAddressMailClientForEachOption
                        };
                    })
                }
            };
        },

        onReset() {
            this.initCopy = initFormCopy();
            this.configForm = configScreenCopy();
            this.initSelectedCustomDomain();
        },

        async handleSelectCampaign() {
            try {
                const dataResCampaign = await this.getDetailDocuments(this.initCopy.campaign);
                handleMapDataCPIntoForm(this.initCopy, dataResCampaign.data);
            } catch (error) {
                console.log('error', error);
            }
        },

        async getListBlockFromAnalytics() {
            try {
                const data = await this.getListBlockOriginalOfForm(this.$route.query.id);
                this.listBlockForm = [...data, { ...OPTION_MAIL_I, block_name: OPTION_MAIL_I.label }];
            } catch (error) {
                console.log('error', error);
            }
        },

        async onGetListCustomDomain() {
            try {
                const response = await this.getListCustomDomain('limit=1000');
                let defaultDomainStr = process.env.VUE_APP_DOMAIN_FORM || '';
                defaultDomainStr = defaultDomainStr.replace(/^https?:\/\//, '');
                let defaultDomain = {
                    id: null,
                    domain: defaultDomainStr
                };
                let customDomains = [];
                if (response?.data) {
                    customDomains = response.data;
                }

                this.listCustomDomains = [defaultDomain, ...customDomains];
                this.initSelectedCustomDomain();
            } catch (error) {
                console.log(error);
            }
        },

        initSelectedCustomDomain() {
            let defaultDomain = this.listCustomDomains.find((item) => item.id === null) || {
                id: null,
                domain: (process.env.VUE_APP_DOMAIN_FORM || '').replace(/^https?:\/\//, '')
            };
            if (this.dataForm?.custom_domain_id) {
                this.selectedCustomDomain =
                    this.listCustomDomains.find((item) => item.id === this.dataForm.custom_domain_id) ||
                    (this.dataForm.custom_domain?.id === this.dataForm.custom_domain_id ? this.dataForm.custom_domain : defaultDomain);
            } else {
                this.selectedCustomDomain = defaultDomain;
            }
            this.initCopy.custom_domain_id = this.selectedCustomDomain ? this.selectedCustomDomain.id : null;
        }
    },

    watch: {
        'config.model': {
            handler(newModel) {
                if (newModel) {
                    this.getListBlockFromAnalytics();
                    this.initCopy = {
                        ...this.initCopy,
                        campaign: this.dataForm?.campaign ?? null,
                        client: this.dataForm?.client ?? null
                    };
                    this.onGetListCustomDomain();
                }
            },
            immediate: true
        },

        mailInfor: {
            handler(newVal) {
                this.formMail = newVal;
            },
            immediate: true
        },

        dataForm: {
            handler(newVal) {
                if (newVal) {
                    this.initSelectedCustomDomain();
                }
            },
            deep: true
        },

        selectedCustomDomain(newVal) {
            this.initCopy.custom_domain_id = newVal ? newVal.id : null;
            if (!newVal && this.listCustomDomains.length > 0) {
                this.selectedCustomDomain = this.listCustomDomains.find((item) => item.id === null) || null;
            }
        }
    },

    mounted() {
        this.onGetListCustomDomain();
    }
};
</script>

<style lang="scss" scoped></style>
